import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import { changeTab, setLoginMode } from 'redux/actions';
import {
    LoginPanel,
    ForgotPasswordPanel,
    RegisterPanel,
    RecognizeEmailLoginPanel,
    NewPasswordPanel,
    SummaryPanel,
    LoginButton
} from './Panels';

const Panels = () => {
    const dispatch = useDispatch();
    const { tab, loginMode, user, resetPassword } = useSelector((state) => state.sign);
    const handleLoginMode = (mode) => dispatch(setLoginMode(mode));

    // useEffect(() => {
    //     setTabsClases(cx({
    //         'full': fullList.includes(loginMode)
    //     }));

    // }, [loginMode, fullList])

    return tab === 'newPassword' ? (
        <NewPasswordPanel />
    ) : (
            <Tabs id="sign-panels" activeKey={tab} onSelect={(k) => dispatch(changeTab(k))} className="full">
                <Tab eventKey="login" title="Logowanie">
                    {
                        {
                            login: <LoginPanel changeEv={handleLoginMode} />,
                            registerSummary: <LoginPanel changeEv={handleLoginMode} />,
                            recognizedEmail: <RecognizeEmailLoginPanel changeEv={handleLoginMode} />,
                            forgotPassword: <ForgotPasswordPanel changeEv={handleLoginMode} />,
                            sentForgotPassword: (
                                <SummaryPanel
                                    changeEv={handleLoginMode}
                                    alertInfo={`Wysłaliśmy na adres ${resetPassword && resetPassword.email
                                        } e-maila z instrukcją zmiany hasła.`}
                                    variant="success"
                                    title="Przypomnienie hasła"
                                />
                            ),

                            setNewPassword: (
                                <SummaryPanel
                                    changeEv={handleLoginMode}
                                    alertInfoHtml={
                                        <p>Twoje hasło zostało poprawnie zmienione. Teraz możesz <LoginButton changeEv={handleLoginMode}>zalogować się</LoginButton> do Twojego konta.</p>
                                    }
                                    variant="success"
                                    title="Sukces!"
                                    hideContent
                                />
                            ),
                        }[loginMode]
                    }
                </Tab>
                <Tab eventKey="register" title="Rejestracja">
                    {loginMode === 'registerSummary' ? (
                        <SummaryPanel
                            changeEv={handleLoginMode}
                            alertInfo={`Rejestracja się udała! Wysłaliśmy e-mail z potwierdzeniem na adres ${user && user.email} `}
                            variant="success"
                            title="Sukces!"
                        />
                    ) : (
                            <RegisterPanel />
                        )}
                </Tab>
            </Tabs>
        );
};

export default Panels;
